import { useEffect, useRef, useState } from 'react';

// TODO: Currently it is not used. Assess if it is needed.
const useDebouncedTransition = (isPending: boolean, delay: number = 10) => {
  const [debouncedPending, setDebouncedPending] = useState(false);

  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isPending) {
      timerRef.current = setTimeout(() => {
        setDebouncedPending(true);
      }, delay);
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setDebouncedPending(false);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isPending, delay]);

  return debouncedPending;
};

export default useDebouncedTransition;
